(() => {
  const roots = document.querySelectorAll('[data-nt-health-guide]');
  if (!roots.length) return;

  roots.forEach((root) => root.setAttribute('data-nt-js-ready', 'true'));

  document.querySelectorAll('.nt-health-guide__references').forEach((references) => {
    const walker = document.createTreeWalker(references, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      if (node.parentElement?.closest('a, script, style')) continue;
      if (/https?:\/\/[A-Za-z0-9._~:\/?#[\]@!$&()*+,;=%-]+/iu.test(node.nodeValue || '')) textNodes.push(node);
    }

    textNodes.forEach((textNode) => {
      const source = textNode.nodeValue || '';
      const fragment = document.createDocumentFragment();
      const pattern = /https?:\/\/[A-Za-z0-9._~:\/?#[\]@!$&()*+,;=%-]+/giu;
      let cursor = 0;
      let match;

      while ((match = pattern.exec(source)) !== null) {
        let candidate = match[0];
        let punctuation = '';
        while (/[。；，、！？）】》〉.,;:!?)\]}]$/u.test(candidate)) {
          punctuation = candidate.slice(-1) + punctuation;
          candidate = candidate.slice(0, -1);
        }

        fragment.append(document.createTextNode(source.slice(cursor, match.index)));
        try {
          const parsed = new URL(candidate);
          if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') throw new Error('Unsupported reference protocol');
          const anchor = document.createElement('a');
          anchor.href = parsed.href;
          anchor.textContent = candidate;
          anchor.className = 'nt-health-guide__reference-link';
          fragment.append(anchor);
        } catch (_error) {
          fragment.append(document.createTextNode(candidate));
        }
        fragment.append(document.createTextNode(punctuation));
        cursor = match.index + match[0].length;
      }

      fragment.append(document.createTextNode(source.slice(cursor)));
      textNode.replaceWith(fragment);
    });
  });

  document.querySelectorAll('[data-nt-copy-link]').forEach((button) => {
    const status = button.parentElement?.querySelector('[data-nt-copy-status]');

    button.addEventListener('click', async () => {
      if (!navigator.clipboard?.writeText) {
        if (status) status.textContent = '請從瀏覽器位址列複製連結。';
        return;
      }

      try {
        await navigator.clipboard.writeText(window.location.href);
        if (status) status.textContent = '文章連結已複製。';
      } catch (_error) {
        if (status) status.textContent = '無法自動複製，請從瀏覽器位址列複製。';
      }
    });
  });

  document.querySelectorAll('[data-nt-product-card]').forEach((card) => {
    card.addEventListener('click', (event) => {
      if (!event.target.closest?.('a[href]')) return;
      const index = Number.parseInt(card.dataset.itemIndex || '0', 10);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'select_item',
        item_list_id: 'health_guide_related_products',
        item_list_name: 'Health Guide Related Products',
        article_handle: card.dataset.articleHandle,
        article_category: card.dataset.articleCategory,
        placement: card.dataset.placement,
        ecommerce: {
          items: [{
            item_id: card.dataset.itemId,
            item_name: card.dataset.itemName,
            item_category: card.dataset.itemCategory,
            index: Number.isNaN(index) ? 0 : index,
          }],
        },
      });
    });
  });

  const tocLinks = [...document.querySelectorAll('.nt-health-guide__toc a[href^="#"]')];
  const observedSections = tocLinks
    .map((link) => document.querySelector(link.getAttribute('href')))
    .filter(Boolean);

  if ('IntersectionObserver' in window && observedSections.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (!visible) return;

        tocLinks.forEach((link) => {
          const active = link.getAttribute('href') === `#${visible.target.id}`;
          if (active) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      },
      { rootMargin: '-15% 0px -70% 0px', threshold: 0 }
    );

    observedSections.forEach((section) => observer.observe(section));
  }
})();
